<template>
    <div class="block-child">
        <BlockParallax class="block-child__icon block-child__icon-sun" speed="10" direction="right" transform="rotate">
            <img src="@/assets/images/icons/sun.png">
        </BlockParallax>
        <BlockParallax class="block-child__icon-cloud-small" speed="10" direction="right" transform="translateX">
            <img src="@/assets/images/icons/cloud-small-white.png">
        </BlockParallax>
        <BlockParallax class="block-child__icon block-child__icon-cloud-big-blue-one" speed="10" direction="right" transform="translateX">
            <img src="@/assets/images/icons/cloud-big-blue.png">
        </BlockParallax>
        <BlockParallax class="block-child__icon block-child__icon-cloud-big-blue-two block-child--icon-desktop" speed="10" direction="right" transform="translateX">
            <img src="@/assets/images/icons/cloud-big-blue.png">
        </BlockParallax>
        <BlockParallax class="block-child__icon block-child__icon-cloud-big-blue-three block-child--icon-desktop" speed="10" direction="right" transform="translateX">
            <img src="@/assets/images/icons/cloud-big-blue.png">
        </BlockParallax>

        <img
            srcset="../assets/1.1-img.jpg, ../assets/1.1-img@2x.jpg 2x"
            src="../assets/1.1-img.jpg"
            class="block-child__img"
        >
        <div class="image-caption image-caption--overlap-left">Двор проекта Green park</div>

        <BlockParallax
            class="block-child__content"
            fixed
            speed="5"
            direction="top"
            transform="translateY"
        >
            <span class="block-child__title">Ребенок и мир</span>
            <p class="block-child__text">
                Дети, которым не мешают спать гудки машин с улицы и шум лифта, действительно существуют. Но не всем
                родителям так везет. В большинстве случаев на помощь приходят хорошие стеклопакеты, современный
                бесшумный лифт и закрытый двор.
            </p>
            <p class="block-child__text">
                Пока ребенок спит, можно сделать какие-то небольшие дела по дому. Правда, некоторые спят только в мерно
                покачивающейся коляске. И если вдруг ребенок начал засыпать еще в квартире, пока вы одевались, без
                широкого лифта и плавного спуска с крыльца, на его спокойный сон можно не рассчитывать.
            </p>
        </BlockParallax>
        <div class="block-child__bg">
            <BlockPram class="block-child__pram block-child__bg-icon" icon-color="yellow" />
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
import BlockPram from '@/components/blocks/pram'
export default {
    components: {
        BlockParallax,
        BlockPram
    }
}
</script>

<style scoped lang="stylus">
    .block-child {
        margin-top: 3rem
        margin-left: -1rem
        margin-right: -1rem
        font-size: 0
        position: relative
        &__bg {
            display: none
            +layout-l-and-up() {
                display: block
                content: '';
                position: absolute;
                left: 50%
                transform translateX(-50%)
                width 100vw
                height 50px;
                background-image url('~@/assets/images/icons/bg-line.svg')
                min-height 800px
                background-repeat no-repeat
                background-size 1700px
                background-position bottom
                bottom 12.6rem
                @media (min-width: 1320px) {
                    background-size 1400px
                }
            }
        }
        &__pram {
            display: none
            +layout-l-and-up() {
                width 13.5rem
                display flex
                bottom -47rem
                left 29.2rem
                transform: rotate(6deg) scale(0.9);
            }
            @media (min-width: 1320px) {
                bottom -50rem
        }
        @media (min-width: 1500px) {
            left 45rem
        }
        @media (min-width: 1680px) {
            left 63rem
        }
    }
    +layout-sm-and-up() {
        margin-left 0
        margin-right 0
    }
    +layout-md-and-up() {
        margin-top 7rem
    }
    &__img {
        position relative
        z-index 4
        object-fit contain
        /*max-width 100%*/
        +layout-sm-and-up() {
            max-width: 100%
        }

        +layout-xs() {
            width 100%
            height 355px
            object-fit cover
        }
    }
    &__content {
        position relative
        max-width 46rem
        background-color: $color-blue
        padding 2rem 2rem 3rem 2rem
        margin-left 4rem
        margin-top: -7rem

        z-index 5

        +layout-sm-and-up() {
            margin-left auto
            margin-right 8rem
        }
        +layout-md-and-up() {
            padding 4rem 6rem
            padding-bottom: 7rem
            margin-top: 4rem
            position: relative
        }
    }
    &__title {
        font-size 2.2rem
        line-height 2.6rem
        font-weight $font-semiBold
        color $color-white
        +layout-md-and-up() {
            font-size 3rem
        }
    }
    &__text {
        color $color-text
        font-size: 1.5rem
        line-height: 2rem
        margin 1.6rem 0 0 0
    }
    &__icon {
        position: absolute
    }
    &--icon-desktop {
        display none
        +layout-md-and-up() {
            display block
        }
    }
    &__icon-sun {
        width 12.7rem
        z-index 100
        right 0
        top -6.4rem
        +layout-md-and-up() {
            width 32.7rem
            z-index 100
            right -60px
            top -23.4rem
        }
    }
    &__icon-cloud-small {
        position absolute
        width 10.7rem
        z-index 100
        right 36px
        top 1.6rem
        +layout-md-and-up() {
            position absolute
            width 17.7rem
            z-index 100
            top 4.6rem
            left -4rem
        }
    }
    &__icon-cloud-big-blue-one {
        position absolute
        width 19.7rem
        z-index 100
        left -8rem
        top 19.6rem
        +layout-md-and-up() {
            position absolute
            width 42.7rem
            z-index 100
            left -46rem
            top 8.6rem
        }
    }

    &__icon-cloud-big-blue-two {
        +layout-md-and-up() {
            position absolute
            width 24.7rem
            z-index 100
            right -2.6rem
            top -54px
        }
    }

    &__icon-cloud-big-blue-three {
        +layout-md-and-up() {
            position absolute
            width 29.7rem
            z-index 100
            right -0.8rem
            top 23rem
        }
    }

    }
</style>
